exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\na[data-v-c3db348c] {\n  text-decoration: underline;\n}\n", ""]);

// exports
